import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const location = useLocation();

  // Show loading while authentication is in progress
  if (inProgress === InteractionStatus.Startup || inProgress === InteractionStatus.HandleRedirect) {
    return (
      <div className="flex flex-col justify-center items-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-shopware-blue mb-4"></div>
        <p className="text-shopware-dark-blue text-xl">Checking authentication...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Nicht authentifizierte Benutzer werden zur Login-Seite umgeleitet
    // Die ursprüngliche URL wird als Query-Parameter gespeichert
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  // Authentifizierte Benutzer können die geschützte Route sehen
  return <>{children}</>;
};

export default ProtectedRoute; 